// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__0miIV","text":"BackButton_text__XW1MC","button":"BackButton_button__kiTju"};